import "./App.css";
import "@fontsource/work-sans";
import "./styles/global.css";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { initVersionCheck, stopVersionCheck } from "./Utils/versionManager";
import LoginPage from "./Pages/Login/login";
import AdminSignup from "./Pages/Admin-signup/Admin-signup";
import AdminLogin from "./Pages/Admin-login/Admin-login";
import AdminDashboard from "./Pages/Admin-Dashboard/Admin-Dashboard";
import DashboardDetails from "./Pages/Dashboard-Details/Dashboard-Details";
import InvestmentDetails from "./Pages/Dashboard-Details/Investment-Details";
import ForgotPassword from "./Pages/Admin-login/Forgot-Password";
import CustomerDetails from "./Pages/Customer/customer-detail";
import InvestmentDetailsByID from "./Components/TableWithFilters/investment-detail";
import CashAccountInvestmentDetails from "./Pages/Dashboard-Details/Investment-Details";
import InvestmentList from "./Pages/My-Investments/investment-list";
import InvestmentHub from "./Pages/InvestmentHub/InvestmentHub";
import Credit from "./Pages/Transaction-Request/Credit";
import Debit from "./Pages/Transaction-Request/Debit";
import DebitRequest from "./Pages/Transaction-Request/DebitRequest";

import UploadGeneralDoc from "./Pages/General/UploadGeneralDoc";
import UploadTransactionReceipt from "./Pages/UploadTransactionReceipt";
import UploadInvestorDoc from "./Pages/UploadInvestorDoc";
import CashAccountAgreement from "./Pages/Customer/CashAccountAgreement";
import EmailESign from "./Pages/Customer/EmailESign";
import UploadCustomerDoc from "./Pages/Customer/UploadCustomerDoc";
import Crypto from "./Pages/Crypto";
import Fum from "./Pages/Fum";
import Trading from "./Pages/Trading";
import Custodian from "./Pages/Custodian";
import Commodities from "./Pages/Commodities";
import Documents from "./Pages/Documents";
import TermsAndConditions from "./Pages/TermsAndConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Securities from "./Pages/Securities/Securities";
import MyInvestment from "./Pages/My-Investments/MyInvestment";
import InvAdvMenu from "./Pages/InvAdvMenu";
// import CashacFees from "./Pages/CashacFees";

import Reports from "./Components/Reports/reports";
import { ToastProvider } from "../src/Utils/toastContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MultiStepSidebarForm from "./Pages/Onboarding/multi-step-sidebar-form";
import MultiStepSidebarFormShareholder from "./Pages/Onboarding-shareholder/multi-step-sidebar-form";

import LoadStocks from "./Pages/Inspecie-Transfer/load-stocks";
import StrategyDetails from "./Pages/Inspecie-Transfer/strategy-detail";
import LoadStocksGuest from "./Pages/Inspecie-Transfer-Guest/load-stocks-guest";
import PortfolioChartSection from "./Pages/Inspecie-Transfer-Guest/strategy-detail";
import Alerts from "./Pages/Alerts/Alerts";
import TransactionRequest from "./Pages/Transaction-Request/TransactionRequest";
import ExternalBanks from "./Pages/ExternalBanks";
import BeneficiaryList from "./Pages/BeneficiaryList";
import MandateDetails from "./Pages/Dashboard-Details/mandate-details";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("jwtToken");
  return token ? children : <Navigate to="/login" />;
};

// Redirect components
const PlatformAgreementRedirect = () => {
  useEffect(() => {
    window.location.href =
      "https://map.admin.caprock.com.au/agreement-doc-view/cash_account_agreement";
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to Platform Agreement...</p>
      </div>
    </div>
  );
};

const IMAgreementRedirect = () => {
  useEffect(() => {
    window.location.href =
      "https://map.admin.caprock.com.au/agreement-doc-view/information_memorandum";
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to IM Agreement...</p>
      </div>
    </div>
  );
};

function App() {
  // Initialize version checking to auto-refresh on new deployments
  useEffect(() => {
    initVersionCheck();

    return () => {
      stopVersionCheck();
    };
  }, []);
  useEffect(() => {
    const checkIndexCache = async () => {
      try {
        // Fetch index.html directly from server
        const response = await fetch("/index.html", {
          method: "GET",
          cache: "no-store", // ensure we get latest
        });

        console.log("--- index.html headers ---");
        console.log("Status:", response.status);
        console.log("Cache-Control:", response.headers.get("Cache-Control"));
        console.log("Pragma:", response.headers.get("Pragma"));
        console.log("Expires:", response.headers.get("Expires"));

        if (
          response.headers.get("Cache-Control")?.includes("no-cache") ||
          response.headers.get("Cache-Control")?.includes("no-store")
        ) {
          console.log("✅ index.html is not cached");
        } else {
          console.warn("⚠️ index.html might be cached! Users may see old UI");
        }
      } catch (err) {
        console.error("Error fetching index.html:", err);
      }
    };

    checkIndexCache();
  }, []);

  return (
    <ToastProvider>
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/sign-up" element={<AdminSignup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/customer-login" element={<LoginPage />} />
          <Route path="/add-stocks-guest" element={<LoadStocksGuest />} />
          <Route
            path="/view-details-guest"
            element={<PortfolioChartSection />}
          />
          <Route
            path="/reports"
            element={
              <AdminDashboard>
                <Reports />
              </AdminDashboard>
              // <ProtectedRoute>
              // </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MultiStepSidebarForm />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding-shareholder/:shareholderId/:shareholderType/:userType/:isShareholder"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MultiStepSidebarFormShareholder  />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/onboarding"
            element={
              <AdminDashboard>
                <MultiStepSidebarForm />
              </AdminDashboard>
            }
          /> */}
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CustomerDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-investments"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-hub"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentHub />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inspecie-transfer"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <LoadStocks />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/strategy-details"
            element={
              <AdminDashboard>
                <StrategyDetails />
              </AdminDashboard>
            }
          />
          <Route
            path="/see-more"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/cashaccount-investment-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CashAccountInvestmentDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <DashboardDetails />
                </AdminDashboard>
              </ProtectedRoute>
              // <DashboardDetails />
            }
          />
          <Route
            path="/investment-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-details-by-id"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentDetailsByID />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mandate-payment-history/:mandateId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MandateDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload-general-doc"
            element={
              // <ProtectedRoute>
              // </ProtectedRoute>
              // <AdminDashboard>
              // </AdminDashboard>
              <UploadGeneralDoc />
            }
          />
          <Route
            path="/upload-transaction-receipt"
            element={<UploadTransactionReceipt />}
          />
          <Route path="/upload-investor-doc" element={<UploadInvestorDoc />} />
          <Route
            path="/cashaccount-agreement"
            element={
              <AdminDashboard>
                <CashAccountAgreement />
              </AdminDashboard>
            }
          />
          <Route path="/email-esign" element={<EmailESign />} />
          <Route path="/upload-customer-doc" element={<UploadCustomerDoc />} />
          {/* Completed */}
          <Route
            path="my-account/crypto"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Crypto />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />{" "}
          {/* Completed */}
          <Route
            path="my-account/fum"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Fum />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-account/property"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Trading />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-account/custodian"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Custodian />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-account/commodities"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Commodities />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-account/securities"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Securities />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-account/my-investment"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MyInvestment />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="investment-advisor-menu/:id"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvAdvMenu />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-documents"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Documents />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="terms-and-conditions"
            element={
              <AdminDashboard>
                <TermsAndConditions />
              </AdminDashboard>
            }
          />
          <Route
            path="privacy-policy"
            element={
              <AdminDashboard>
                <PrivacyPolicy />
              </AdminDashboard>
            }
          />
          <Route
            path="platform-agreement"
            element={
              <AdminDashboard>
                <PlatformAgreementRedirect />
              </AdminDashboard>
            }
          />
          <Route
            path="im-agreement"
            element={
              <AdminDashboard>
                <IMAgreementRedirect />
              </AdminDashboard>
            }
          />
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Alerts />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="cashac-fees"
            element={
              <AdminDashboard>
                <CashacFees />
              </AdminDashboard>
            }
          /> */}
          <Route
            path="/credit-request"
            element={
              <AdminDashboard>
                <Credit />
              </AdminDashboard>
            }
          />
          <Route
            path="/debit-request"
            element={
              <AdminDashboard>
                <Debit />
              </AdminDashboard>
            }
          />
          <Route
            path="/transaction-request"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TransactionRequest />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/external-banks"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ExternalBanks />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-beneficiary"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <BeneficiaryList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
